module.exports = __webpack_public_path__ + "img/log-it-logo-opacity.a85cc081.png";